import {
  aCreateCustomerSourcedEntityLookupTable,
  mockCreateCustomerSourcedEntityLookupTableOperationMutation,
} from '__generated__';
import { delay, HttpResponse } from 'msw';

export const handlers = [
  mockCreateCustomerSourcedEntityLookupTableOperationMutation(
    async ({ query: _query, variables: _variables }) => {
      await delay(1500);
      return HttpResponse.json({
        data: {
          __typename: 'Mutation',
          createCustomerSourcedEntityLookupTable:
            aCreateCustomerSourcedEntityLookupTable(),
        },
      });
    }
  ),
];
